import { Card } from "react-bootstrap";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import { SkillTags } from "./SkillsTag";
import "./PersonalProjectCard.css";

export const PersonalProjectCard = ({
  title,
  description,
  imgUrl,
  github,
  demo,
  skills,
}) => {
  return (
    <Card className="project-card-personal d-flex flex-column">
      <Card.Img variant="top" src={imgUrl} className="project-img-personal" />
      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="mb-0">{title}</h5>
          <div className="icon-row">
            <a href={github} target="_blank" rel="noopener noreferrer">
              <FaGithub size={20} />
            </a>
            <a href={demo} target="_blank" rel="noopener noreferrer">
              <FaExternalLinkAlt size={18} />
            </a>
          </div>
        </div>
        <div className="clamped-text">{description}</div>
        {skills && <SkillTags skills={skills} />}
      </Card.Body>
    </Card>
  );
};
